import { LoadingButton } from '@mui/lab'
import { useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import api from '../../Apis';
import Swal from 'sweetalert2';
import UploadRoundedIcon from '@mui/icons-material/UploadRounded';


export default function ButtonUploadVideo (props) {
  const { t, i18n } = useTranslation();
  const [state, setState] = useState({
    loading_upload_video: false
  })
  const inputFile = useRef(null);

  const onChangeFile = (e) => {
    const file = e.target.files;
    if (file.length > 0) {
        const formData = new FormData();
        formData.append('video', file[0]);
        formData.append('fanpage_id', props.fanpage_id);
        formData.append('lang', i18n.language);
        formData.append('folder_id', props.folder_selected.folder_id);
        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + props.cookie
            },
            body: formData
        };
        setState({...state, loading_upload_video: true})
        fetch(api.upload_video, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    props.updateAttachment([result.datas]);
                    setState({
                        ...state,
                        loading_upload_video: false
                    })
                } else {
                    if (result.type == "validate") {
                        Swal.fire(result.errors, "", "warning");
                    } else {
                        Swal.fire(result.message, "", "warning");
                    }
                }
            }
        )
    }
}

  return (
    <LoadingButton loading={ state.loading_upload_video } sx={{
      marginRight: '20px'
      }} onClick={() => inputFile.current.click()} variant="outlined" color="warning" startIcon={<UploadRoundedIcon />}>
      {t("common.upload.uploadVideo")}
      <input style={{display: 'none'}} ref={inputFile} onChange={onChangeFile} multiple type="file" className='file'/>
  </LoadingButton>
  )
}

